import MobilePopup from '../newPopup/mobilePopup/MobilePopup';
import * as css from './ArrivalConfirmationPopup.css';
import {TShow} from '../prompotionPopup/PromotionPopup';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import {getEmailData, getSuspendedOrders, sendConfirmations} from '../../redux/branding/brandingActions';
import FormStage from './formStage/FormStage';
import PreviewStage from './previewStage/PreviewStage';
import SendStage from './sendStage/SendStage';
import {getStaticImage} from '../../globalVariables/GlobalVariables';
import {Formik} from 'formik';
import {useNavigate} from 'react-router-dom';

function ArrivalConfirmationPopup({show}: {show: TShow}) {
    const {t} = useTranslation('suspendedConfirmation');
    const [stage, setStage] = useState('form');
    const formRef = useRef(null);
    const navigate = useNavigate();
    const initialValues = {
        // whatsApp: false,
        email: true,
        sms: false
    };
    const icon = stage === 'send' ? getStaticImage('app/ArrivalConfirmation/bell.png') : getStaticImage('app/ArrivalConfirmation/fly.png');

    const eid = useSelector((s: any) => s.event.eid);
    const {getSuspendedOrdersXHR, suspendedOrders, getBrandingData, currentLang} = useSelector((s: any) => ({
        getSuspendedOrdersXHR: s.branding.getSuspendedOrdersXHR,
        suspendedOrders: s.branding.suspendedOrders,
        getBrandingData: s.branding.getBrandingData,
        currentLang: s.branding.currentLang
    }));

    useEffect(()=>{
        if(!getBrandingData?.[`${currentLang}XHR`])
            getEmailData().then();
    },[currentLang]);
    
    const handleEdit = () => {
        navigate(`/e/${eid}/tickets/branding/arrivalConfirmation`);
        show.close();
    };
    const handleSubmit = (values) => {
        setStage('send');
        sendConfirmations(values).then();
    };

    useEffect(() => {
        if(getSuspendedOrdersXHR !== 'LOADING') {
            getSuspendedOrders().then();
        }
    }, [eid]);

    const handleBack = () => {
        if(stage === 'preview') {
            setStage('form');
        } else {
            show.close();
        }
    };

    const content = {
        form: <FormStage 
            onSave={() => setStage('preview')}
        />,
        preview: <PreviewStage 
            onEdit={handleEdit} 
        />,
        send: <SendStage 
            suspendedOrders={suspendedOrders} 
            onClose={show.close}
        />
    };
    return (
        <css.wrapper data-cy='popupAfterAdvertise' $back={stage === 'preview'}>
            <MobilePopup 
                showClass={show.showClass}
                close={handleBack}
                dataCyName={'PromotionPopup'} 
                title={stage === 'preview' ? t('preview') : ''} 
                list={undefined} 
                forwardRef={undefined}            
            >
                {stage === 'form' ? <css.main>
                    <css.title>{t('popupTitle')}</css.title>
                    <css.text>{t('popupSubtitle')}</css.text>
                    <css.text>{t('popupSubtitleSecond', {number: suspendedOrders})}</css.text>
                    <css.icon $icon={icon} />  
                </css.main> : <>{stage === 'preview' && <css.main>
                    <css.title>{t('preview')}</css.title>
                </css.main>}
                <css.icon $icon={icon} /></>}
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={formRef}
                >
                    {content[stage]}
                </Formik>
            </MobilePopup>
        </css.wrapper>
    );
}

export default ArrivalConfirmationPopup;
